export function activeCompanyID() {
  const stored = localStorageValue("activeCompanyId") || localStorageValue("cowork.agent.companyId")
  return (
    (stored && sessionStorageValue("cowork.activeCompanyId")) ||
    stored ||
    import.meta.env.VITE_AGENT_COMPANY_ID ||
    "00000000-0000-0000-0000-000000000101"
  )
}

export function setActiveCompanyID(companyID: string) {
  if (!companyID || companyID === "ALL") return
  try {
    sessionStorage.setItem("cowork.activeCompanyId", companyID)
  } catch {
    // The shared preference remains usable when per-tab storage is unavailable.
  }
  try {
    localStorage.setItem("activeCompanyId", companyID)
    localStorage.setItem("cowork.agent.companyId", companyID)
  } catch {
    return
  }
}

export function recoverActiveCompanyID(companyID: string) {
  try {
    localStorage.removeItem("cowork.workspace.entityId")
    localStorage.removeItem("cowork.workspace.projectId")
    localStorage.removeItem("cowork.workspace.periodId")
    localStorage.removeItem("cowork.agent.selectedProjectId")
    localStorage.removeItem("cowork.agent.selectedWorkflowId")
  } catch {
    // The active company can still be corrected when scoped preferences are unavailable.
  }
  setActiveCompanyID(companyID)
}

export function localDevHeaders() {
  return {
    "X-User-Id": localStorageValue("cowork.agent.userId") || import.meta.env.VITE_AGENT_USER_ID || "00000000-0000-0000-0000-000000000001",
    "X-User-Email": localStorageValue("cowork.agent.userEmail") || import.meta.env.VITE_AGENT_USER_EMAIL || "user@cowork.ai",
    "X-Active-Company-Id": activeCompanyID(),
  }
}

function localStorageValue(key: string) {
  try {
    return localStorage.getItem(key) || ""
  } catch {
    return ""
  }
}

function sessionStorageValue(key: string) {
  try {
    return sessionStorage.getItem(key) || ""
  } catch {
    return ""
  }
}
